import { Close, CloseSharp, Delete, Save } from "@mui/icons-material";
import {
  Autocomplete,
  Button,
  Grid,
  IconButton,
  Stack,
  TextField,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useTheme } from "@mui/material/styles";
import { Formik } from "formik";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import axios from "../axiosInstances";
import { ShoppingCartContext } from "./Context/ShoppingCartContext";
const validationSchema = Yup.object().shape({
  Type: Yup.string()
    .required("Type is required!!!"),
  Description: Yup.string()
    .required("Description is required!!!"),
});
export default function SettingModel(props) {
  const theme = useTheme();
  const { t, i18n } = useTranslation();

  const [open, setOpen] = useState(false);
  const { globalUser, globalToken } = useContext(ShoppingCartContext);

  const [id] = useState(props?.data?.Id);
  const [type, setType] = useState(props?.data?.Type);
  const [description, setDescription] = useState(props?.data?.Description);
  const [value, setValue] = useState(props?.data?.Value);
  const [remark, setRemark] = useState(props?.data?.Remark);

  const handleSubmit = (values) => {
    alert('inninin')
    /*  if (type === undefined || type === null || type.length <= 0) {
       alert("select type first");
       return;
     }
     if (
       description === undefined ||
       description === null ||
       description.length <= 0
     ) {
       alert("Write description first");
       return;
     }
     if (value === undefined || value === null || value.length <= 0) {
       alert("Write value first");
       return;
     } */
    if (window.confirm("Are you sure you want to save?")) {
      try {
        var fd = new FormData();
        fd.append("Id", id);
        fd.append("Type", values.Type);
        fd.append("Description", values.Description);
        fd.append("Value", values.Value);
        fd.append("Parent", globalUser.Parent);
        fd.append("Remark", values.Remark);

        axios.post("/settings", fd, {
          headers: { "Content-Type": "application/json", token: globalToken },
        });
      } catch (err) {
      } finally {
        props.setParentUpdate(!props.ParentUpdate);
        setOpen(false);
      }
    }
  };
  const handleDelete = () => {
    try {
      axios.delete("/settings?Id=" + id, {
        headers: {
          token: globalToken,
        },
      });
    } catch (err) {
    } finally {
      props.setParentUpdate(!props.ParentUpdate);
      setOpen(false);
    }
  };

  return (
    <div width="500">
      <label onClick={() => setOpen(true)}>{props.icon}</label>
      <Formik
        initialValues={props.data}
        onSubmit={
          handleSubmit
        }
        validationSchema={validationSchema}
        enableReinitialize
      >
        {({ values, errors, handleChange, handleBlur, handleSubmit }) => (
          <Dialog
            maxWidth="md"
            /*      PaperProps={{
               sx: {
                 height: '80vh',   // 80% of viewport height
                 maxHeight: '90vh',
               },
             }} */
            PaperProps={{
              style: {
                borderRadius: 24,
                backgroundColor: '#fffcf9', // Warm off-white
                boxShadow: '0 8px 30px rgba(0,0,0,0.08)'
              }
            }}

            open={open}
            onClose={() => {
              setOpen(false);
            }}
            aria-labelledby="responsive-dialog-title"
          >
            <DialogTitle
              style={{
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                height: "20px",
              }}
            >
              <Stack direction='row' style={{ flex: 1 }}>
                <div style={{ flex: 1 }}>
                  {props.Title}{" "}
                </div>
                <IconButton style={{ backgroundColor: theme.palette.primary.light }} onClick={() => setOpen(false)} size="small"><CloseSharp /></IconButton>
              </Stack>
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                <hr></hr>

                <Grid container>
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      disabled={type === "System" ? true : false}
                      disablePortal
                      selectOnFocus
                      autoHighlight
                      name="Type"
                      getOptionLabel={(option) => option}
                      value={values.Type}
                      onChange={(e) => {
                        values.Type = e.target.textContent;
                      }}
                      onBlur={handleBlur("Type")}
                      options={[
                        "Role",
                        "Bank",
                        "Business Group",
                        "Chart of Account Category",
                        "Fixed Asset Group",
                        "News Category",
                        "Job Title",
                        "Sub Speciality",
                      ]}
                      sx={{
                        width: "95%",
                        marginBottom: 2,
                        borderRadius: "25%",
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Type"
                          variant="standard"
                        //error={!fromAirport ? true : false}
                        />
                      )}
                    />
                    {errors.Type && (
                      <span style={{ color: "red" }}> {errors.Type}</span>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      disabled={type === "System" ? true : false}
                      size="small"
                      variant="standard"
                      label={t("Description")}
                      name="Description"
                      value={values.Description}
                      onChange={
                        handleChange("Description")
                      }
                      onBlur={handleBlur("Description")}
                      sx={{ width: "95%", marginBottom: 2 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                    {errors.Description && (
                      <span style={{ color: "red" }}> {errors.Description}</span>
                    )}
                  </Grid>


                  <Grid item xs={12} md={6}>
                    {type === "Chart of Account Category" ? (
                      <Autocomplete
                        disablePortal
                        selectOnFocus
                        autoHighlight
                        value={values.Value}
                        id="type"
                        onChange={
                          handleChange("Value")
                        }
                        options={
                          props.ChartofAccountParent ?
                            props.ChartofAccountParent.map((st) => st.Description) : ['']
                        }
                        sx={{
                          width: "95%",
                          marginBottom: 2,
                          borderRadius: "25%",
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Parent Category"
                            variant="standard"
                          //error={!fromAirport ? true : false}
                          />
                        )}
                      />
                    ) : (
                      <TextField
                        size="small"
                        variant="standard"
                        label="value"
                        defaultValue={values.Value}
                        multiline
                        maxRows={4}
                        sx={{ width: "95%", marginBottom: 2 }}
                        onChange={handleChange("Value")}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      size="small"
                      variant="standard"
                      label="Remark"
                      defaultValue={values.Remark}
                      multiline
                      maxRows={4}
                      sx={{ width: "95%", marginBottom: 2 }}
                      onChange={handleChange("Remark")}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Grid>
                </Grid>

                <hr></hr>
              </DialogContentText>
            </DialogContent>
            <DialogActions
              style={{
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                flexWrap: 'wrap',
              }}
            >
              <Button
                variant="standard"
                sx={{
                  borderRadius: 5,
                  fontSize: "10px",
                  backgroundColor: theme.palette.primary.main,
                  '&:hover': { backgroundColor: theme.palette.primary.light }
                }}
                endIcon={<Save />}
                autoFocus
                onClick={(e) => {
                  handleSubmit(values);
                }}
              >
                Save
              </Button>
              |
              <Button
                variant="standard"
                sx={{
                  borderRadius: 5,
                  fontSize: "10px",
                  backgroundColor: theme.palette.primary.main,
                  '&:hover': { backgroundColor: theme.palette.primary.light }
                }}
                endIcon={<Delete />}
                autoFocus
                onClick={() => handleDelete()}
              >
                Delete
              </Button>
              |
              <Button
                variant="standard"
                sx={{
                  borderRadius: 5,
                  fontSize: "10px",
                  backgroundColor: theme.palette.primary.main,
                  '&:hover': { backgroundColor: theme.palette.primary.light }
                }}
                endIcon={<Close />}
                onClick={() => setOpen(false)}
                autoFocus
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Formik>
    </div>
  );
}
